module.exports = __webpack_public_path__ + "static/media/Exportall_grey.ad4924d2.svg";